import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"

import { useDuplicateProject } from "entities/projects/api/useDuplicateProject"
import { useProject } from "entities/projects/model/useProject"

import { DuplicateProjectOverlayProps } from "../DuplicateProjectOverlay"
import { DuplicateProjectOverlayViewModel } from "../DuplicateProjectOverlayView"

export function useDuplicateProjectOverlayViewModel({
  payload: { projectID }
}: DuplicateProjectOverlayProps): DuplicateProjectOverlayViewModel {
  const { project } = useProject(projectID)
  const { closeOverlay } = useCurrentOverlay()
  const { duplicateProject } = useDuplicateProject()

  return {
    project,
    onDuplicate: duplicateProject,
    onClose: closeOverlay
  }
}
